import React from "react";
import { TWalletData } from "../../types/PrincipalPositionTypes";
import { TooltipHost } from "@fluentui/react";

const BASE_CLASS = "tableDistribution";

type TTableDistributionProps = {
    walletData: TWalletData
};

const TableDistribution: React.FC<TTableDistributionProps> = ({ walletData }) => {
  const localTheme = window.localStorage.getItem("theme") || "light";
  return (
      <div className={BASE_CLASS}>
        {walletData.walletProductInfo &&
            <table>
              <thead>
                <tr>
                  <th className={`${BASE_CLASS}__${localTheme}`}>HOLDINGS</th>
                  <th className={`${BASE_CLASS}__${localTheme}`}>CARTERA</th>
                    {walletData.walletProductInfo.map(product => 
                      <th>
                        <TooltipHost content={product.name}>

                          <h4 className={`${BASE_CLASS}__${localTheme}`}>{product.isin}</h4>
                          <span>{product.name}</span>
                          <p className={`${BASE_CLASS}__${localTheme}`}>{(product.weight * 100).toFixed(2)}%</p>
                        </TooltipHost>
                      </th>
                    )
                  }
                </tr>
              </thead>
                <tbody>
                  {walletData.holdingInfo?.map((data, index) => (
                    <tr key={index}>
                      <td>
                        <TooltipHost content={data.holdingName}>
                          <div className={`${BASE_CLASS}__truncate`}>
                            <strong>{data.holdingName}</strong>
                          </div>
                        </TooltipHost>
                      </td>
                      <td>{data.holdingSumatory > 0.001
                        ? data.holdingSumatory + "%"
                        : "0.00%"
                      }</td>
                      {data.holdingPercentaje?.map((percentaje, idx) => (
                          <td className={`
                            ${percentaje !== 0
                              ? percentaje > 10
                                ? `${BASE_CLASS}__blue`
                                : `${BASE_CLASS}__green`
                              : ""}
                            ${index === walletData.holdingInfo.length - 1 ? `${BASE_CLASS}__transparent-bg` : ""}`}
                          key={idx}>
                            { percentaje > 0.001
                                ? percentaje.toFixed(2) + "%"
                                : percentaje === 0
                                  ? "-"
                                  : "0.00%"
                              
                            }
                          </td>   
                      ))}
                    </tr>
                    
                  ))}
                </tbody>
            </table>
        }
      </div>
    );

};

export default TableDistribution;